module.exports = __webpack_public_path__ + "img/MG_2623.433871ff.jpg";